import { useSetAtom } from 'jotai';
import {
  activeRectAtom,
  resultRectAtom,
  selectedEventDescriptionsAtom,
  selectedVisEventsAtom,
} from '@/atoms/vis/selection';
import { DEFAULT_SELECTION_LAYER_ATTRIBUTES } from '@/consts/selection';

export const useResetSelectionLayer = () => {
  const setActiveRect = useSetAtom(activeRectAtom);
  const setResultRect = useSetAtom(resultRectAtom);
  const setSelectedEvents = useSetAtom(selectedVisEventsAtom);
  const setSelectedEventDescriptions = useSetAtom(selectedEventDescriptionsAtom);

  const resetSelectionLayer = () => {
    setSelectedEvents(null);
    setSelectedEventDescriptions([]);
    setActiveRect(DEFAULT_SELECTION_LAYER_ATTRIBUTES);
    setResultRect(DEFAULT_SELECTION_LAYER_ATTRIBUTES);
  };

  return resetSelectionLayer;
};
